import React from 'react';
import Input from "../Input-new/Input";
import SelectFirm from "../SelectFirm/SelectFirm";
import PropTypes from "prop-types";
import Control from "../Control";
import RecordGroupFilterDropdown from "../RecordGroups/RecordGroupFilterDropdown";

const AgentForm = ({theme = 'white', width, data, paneIndex, isFilter = false, showGroupFilter = false, ownerAgentId, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange, addNewItem, newFirm}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Agent' : 'Add Agent'}</div>
                {
                    isFilter && showGroupFilter &&
                    <RecordGroupFilterDropdown theme={theme}
                                               groupType='people'
                                               ownerAgentId={ownerAgentId}
                                               value={data.group_id}
                                               valueKey='group_id'
                                               label='People Group'
                                               data={data}
                                               handleParentChange={handleParentDropdownChange}
                    />
                }
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='first_name'
                       label='First Name'
                       value={data.first_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='last_name'
                       label='Last Name'
                       value={data.last_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='phone'
                       label='Work Phone'
                       value={data.phone}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='cell_phone'
                       label='Cell Phone'
                       value={data.cell_phone}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType={isFilter ? 'text' : 'email'}
                       name='email'
                       label='Email'
                       value={data.email}
                       handleParentChange={handleParentChange}
                />
                <SelectFirm theme={theme}
                            width={width}
                            value={data.firm}
                            valueKey='firm'
                            label='Company'
                            data={data}
                            hasDrawer={!isFilter}
                            handleParentChange={handleParentDropdownChange}
                            addNewItem={addNewItem}
                            withAddNew={!isFilter}
                            newFirm={newFirm}
                />
            </React.Fragment>
        ),
    ];
    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

AgentForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    showGroupFilter: PropTypes.bool,
    ownerAgentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
    addNewItem: PropTypes.func,
    newFirm: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export default AgentForm;